"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var diveSaver_all_sidecar_1 = require("@dive/saver/diveSaver_all-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_enemy_sidecar_1 = require("@voyage/crew/diveCrew_enemy-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_LoadState;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.writeStringLong(m, d.state);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        state: messageWriter_sidecar_1.messageWriter.readStringLong(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        state: 'this is some test state!',
    };
    messageWriter_sidecar_1.messageWriter.test('loadState', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msg = read(m);
    //if (isFromHost) {
    // console.log('process load state', msg.state)
    console.log('!! Dive LOAD STATE from message');
    diveSaver_all_sidecar_1.diveSaver_all.read(msg.state);
    console.log('Heroes: ', diveCrew_hero_sidecar_1.diveCrew_hero.countLiveHeroes());
    console.log('Enemies: ', diveCrew_enemy_sidecar_1.diveCrew_enemy.countEnemies());
    // TODO: need a pause / unpause message to reset stuff
    diveSimulationManager_sidecar_1.diveSimulationManager.resetDueToLoad();
    // TODO: Do this only if a new level? Separate into separate message?
    var tile = diveTilemap_sidecar_1.diveTilemap.findFirstTile(function (t) { return t.tile1.type === diveTileData_1.EDiveTile.StairsUp; });
    if (tile) {
        voyageCamera_sidecar_1.voyageCamera.centerOn(tile.x, tile.y);
        voyageCamera_sidecar_1.voyageCamera.setZoom(0.5);
    }
    //}
}
exports.process = process;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true, 1024 * 1024);
}
exports.sendMessageToAll = sendMessageToAll;
